import Meta from "@/vuex/models/meta";
import OrganisationRequest from "@/vuex/models/org-request/org-request";

export default class OrganisationRequestsState {
    public requests: OrganisationRequest[] = [];
    public meta!: Meta;
}
